import { Box } from 'components/UI';
import React from 'react';

import { Props } from './ListItem.types';
import styles from './ListItem.module.scss';
import { Button } from 'modules/af_cm_ui_kit/components';

const ListItem: React.FC<Props> = ({ item, onClick }) => {
  return (
    <Box className={styles.wrapper}>
      <div className={styles.item}>
        <span>{item.label}</span>
        <div className={styles.actions}>
          <Button onClick={onClick.bind(null, 'edit')}>Edit</Button>
          <Button onClick={onClick.bind(null, 'delete')}>
            <svg width="14" height="14" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14 1H10.5L9.5 0H4.5L3.5 1H0V3H14V1ZM1 16C1 16.5304 1.21071 17.0391 1.58579 17.4142C1.96086 17.7893 2.46957 18 3 18H11C11.5304 18 12.0391 17.7893 12.4142 17.4142C12.7893 17.0391 13 16.5304 13 16V4H1V16Z"
                fill="#3A4451"
              />
            </svg>
          </Button>
        </div>
      </div>
    </Box>
  );
};

export default ListItem;
